import React from "react";
import "./Skills.css";
import SkillSection from "./SkillSection";
import { Fade } from "react-reveal";
import LightTheme from "../../theme";

export default function Skills(props) {
  const { role, theme } = props;

  return (
    <div className="main" id="skills">
      <div className="skills-header-div">
        <Fade bottom duration={2000} distance="20px">
          <h1
            className="skills-header"
            style={{ color: LightTheme.text, marginTop: 0 }}
          >
            Here's what I do
          </h1>
        </Fade>
      </div>
      <SkillSection theme={theme} role={role} />
    </div>
  );
}
